import React from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";

import Button from "../../components/button";
import ICInput from "../../components/form/input";

const InstantSwitchConsultCostForm = props => {
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            description: props.consult !== null ? props.consult.description : "",
            cost: props.consult !== null ? props.consult.consultPrice : ""
        },
        validationSchema: Yup.object({
            description: Yup.string()
                .min(2, "Consult description must be of minimum length 2")
                .required("Please enter Consult Description"),
            cost: Yup.string().required("Please enter Consult Cost")
        }),
        onSubmit: values => {
            let formData = new FormData();
            formData.append("consultPrice", values.cost);
            formData.append("description", values.description);

            // if the form is in update state
            if (props.consult !== null) {
                formData.append("consultDetailId", props.consult._id);
                props.onEditSubmit(formData);
                formik.resetForm();
            }
            // if the form is in add state
            else {
                props.onAddSubmit(formData);
                formik.resetForm();
            }

            setTimeout(() => {
                formik.resetForm();
            }, 3000);
        }
    });

    return (
        <form
            className="container d-flex flex-column mr-4 pr-4"
            onSubmit={formik.handleSubmit}
        >
            <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                    Consult Cost ($) <span className="error">*</span>:
                </label>
                <div className="col-sm-8">
                    <ICInput
                        name="cost"
                        type="text"
                        value={formik.values.cost}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.cost && formik.errors.cost ? true : false}
                        helperText={
                            formik.touched.cost && formik.errors.cost
                                ? formik.errors.cost
                                : ""
                        }
                    />
                </div>
            </div>

            <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                    Description <span className="error">*</span>:
                </label>
                <div className="col-sm-8">
                    <ICInput
                        name="description"
                        type="text"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.description && formik.errors.description
                                ? true
                                : false
                        }
                        helperText={
                            formik.touched.description && formik.errors.description
                                ? formik.errors.description
                                : ""
                        }
                    />
                </div>
            </div>
            <br />
            <p className="mb-0 d-flex justify-content-center">
                <Button
                    title={props.consult !== null ? "Update" : "Save"}
                    type="submit"
                />
            </p>
        </form>
    );
};

export default InstantSwitchConsultCostForm;

InstantSwitchConsultCostForm.defaultProps = {
    consult: null,
    onAddSubmit: () => { },
    onEditSubmit: () => { }
};

InstantSwitchConsultCostForm.propTypes = {
    consult: PropTypes.object,
    onAddSubmit: PropTypes.func,
    onEditSubmit: PropTypes.func
};
